import { Component, Input, OnInit } from '@angular/core';

import { ModalService } from '../modal.service';
import { AbstractModal } from '../AbstractModal';

@Component({
  selector: 'ls-confirm-modal',
  templateUrl: './confirm-modal.component.html'
})
export class ConfirmModalComponent extends AbstractModal implements OnInit {
  @Input()
  public data: any;

  constructor(private modal: ModalService) {
    super();
  }

  public ngOnInit(): void {
    this.data.confirm = this.data.confirm || 'Yes';
    this.data.cancel = this.data.cancel || 'No';
  }

  public close(answer: boolean = false): void {
    this.modal.close(answer);
  }
}
